import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import Loader from './Loader'


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Loader/>
  </React.StrictMode>,
)
